import styled from "styled-components";

const size = {
  small: 14,
  large: 20,
};
const inputSize = {
  small: `width: ${size.small}px; height: ${size.small}px;`,
  large: `width: ${size.large}px; height: ${size.large}px;`,
};
const checkedSize = {
  small: `width: ${size.small - 6}px; height: ${size.small - 6}px;`,
  large: `width: ${size.large - 6}px; height: ${size.large - 6}px;`,
};

export const OptionInput = styled.input`
  display: none;
`;
export const CustomRadioOption = styled.label`
  display: flex;
  align-items: center;
  input[type="radio"] {
    display: none;
  }
`;
export const StyledOptionButton = styled.div`
  ${(props) => (props.btnSize === "small" ? inputSize.small : inputSize.large)};
  border-radius: 50%;
  border: 1px solid #666666;
  position: relative;

  input[type="radio"]:checked + &::after {
    ${(props) =>
      props.btnSize === "small" ? checkedSize.small : checkedSize.large};
    content: "";
    background-color: #00af4d;
    position: absolute;
    top: 2px;
    left: 2px;
    border-radius: 50%;
  }
`;

export const OptionLabel = styled.span`
  margin-left: 1rem;
  margin-right: 1rem;
  cursor: pointer;
  width: 200px;
`;
